import react from "react";
import ContentUsuarioUpdate from "./ContentUsuarioUpdate";

const EditarUsuario = () => {
  return (
    <>
      <ContentUsuarioUpdate />
    </>
  );
};

export default EditarUsuario;
